"use strict";
/*
 * Created on 11 26 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Represents binding between {@link Supplier suppliers}, {@link InternalSite internal site} and {@link Product internal product}.
 * This representation should be used for aggregation over {@link GroupOfSites group of sites} ({@link PriceZone price zone}).
 *
 * @author JMe
 */


var SupplierSiteBinding =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(SupplierSiteBinding, _StateDomainObject_1$);

  /**
   * @param id the internal id
   * @param externalId
   * @param supplierId the internal id of supplier
   * @param siteId the internal id of internal site
   * @param productId the internal id of internal product
   * @param preferred flag indicating whether supplier is preferred for given site and product (max 1 is allowed).
   * @param validFrom start of validity of the binding
   * @param validTo end of validity of the binding
   * @param stockRef if true, {@link SupplierSiteBinding.siteId} is reference to stock, if false, it is reference to {@link InternalSite}.
   * @param stateFlags
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function SupplierSiteBinding(id, externalId, supplierId, siteId, productId, preferred, validFrom, validTo, stockRef, stateFlags, processed) {
    var _this;

    _classCallCheck(this, SupplierSiteBinding);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierSiteBinding).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.supplierId = supplierId;
    _this.siteId = siteId;
    _this.productId = productId;
    _this.preferred = preferred;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.stockRef = stockRef;
    _this.stateFlags = stateFlags;
    _this.processed = processed;
    return _this;
  }

  return SupplierSiteBinding;
}(StateDomainObject_1.StateDomainObject);

exports.SupplierSiteBinding = SupplierSiteBinding; // tslint:disable-next-line:member-ordering

SupplierSiteBinding.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SupplierSiteBinding.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    supplierId: builder.str('supplierId'),
    siteId: builder.str('siteId'),
    productId: builder.str('productId'),
    preferred: builder.bool('preferred'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN),
    stockRef: builder.bool('stockRef'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    processed: builder.bool('processed')
  };
}();